import { useLocation, useNavigate } from "react-router-dom";
import {
  getStoreLocalData,
  getUserData,
} from "../../utils/localStorage";
import StatusFilterModal from "../StatusFilterModal";
import { useEffect, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import ButtonLink from "../../ButtonLink";
import useOrders from "../StoreContext/useOrders";
import AdminMenu from "../AdminMenu";
import { getFranchiseRateList, getFranchiseStoreServiceWiseRevenue } from "../../services/FranchiseModal/Franchise";
import SchedularModalFranchise from "../SchedularModalFranchise";
import { localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";

const FranchiseStoreServiceWiseRevenueAdmin = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { item } = location.state || {};
  const { userProfileRole, brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();

  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [franchiseOrderRevenueData, setFranchiseOrderRevenueData] = useState(
    []
  );

  const [visible, setVisible] = useState(false);

  const {
    schedularDate,
    setSchedularDate,
    selectedStatus,
    setSelectedStatus,
    upDateSelectedStatus,
    setUpDateSelectedStatus,
    useEffectCall,
    setUseEffectCall,
  } = useOrders();

  const initializeVariable = () => {
    setFranchiseOrderRevenueData([]);
  };

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  // const [schedularDate, setSchedularDate] = useState({});
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);

    setSchedularDate(newSchedular);
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setUseEffectCall(true);

    setSelectedStatus(selectedStatus);
  };


  // let initialStartDate = new Date();
  // initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  let initialStartDate = new Date();
  initialStartDate.setDate(1); // Set to the 1st of the current month

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [localFranchiseRateValue, setLocalFranchiseRateValue] = useState([]);
  const [apiCall, setApiCall] = useState(false)
  const fetchStoreOrderRevenue = (data) => {
    getFranchiseStoreServiceWiseRevenue(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setApiCall(true)
          setFranchiseOrderRevenueData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  // for all status and one week data or by default data;
  const data = {
    storeIds: [item.storeId],
    brandId: brandId,
    statusIn: [
      "BOOKED",
      "INPROCESS",
      "IN_WAREHOUSE",
      "PROCESSED",
      "DELIVERED",
      "DONE",
      // "CANCEL",
      // "UNPROCESSED",
      "OUT_FOR_DELIVERY",
      "DELAY_STATUS",
    ],
    startDate: localeDateStartDate(new Date(startDate)),
    endDate: localeDateEndDate(new Date(endDate)),
  };

  const [requestData, setRequestData] = useState(data);

  const OrderStatusColors = [
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#000",
  ];

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      if (selectedStatus !== "ALL") {
        requestData.statusIn = selectedStatus;
      } else {
        requestData.statusIn = [
          "BOOKED",
          "INPROCESS",
          "IN_WAREHOUSE",
          "PROCESSED",
          "DELIVERED",
          "DONE",
          "CANCEL",
          "UNPROCESSED",
          "OUT_FOR_DELIVERY",
          "DELAY_STATUS",
        ];
      }
      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(new Date(endDate));
      fetchStoreOrderRevenue(requestData);
    }
  }, [schedularDate, selectedStatus, item]);

  useEffect(() => {
  fetchFranchiseRate();
  }, [])

  const fetchFranchiseRate = () => {
    getFranchiseRateList(brandId, item.brandFranchise.id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setLocalFranchiseRateValue(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const prepareExportData = () => {
    const serviceRateList = localFranchiseRateValue.filter(
      (itemRate) =>
        itemRate.status === true && itemRate.calculationMode === "SERVICE"
    );

    const entries = serviceRateList[0]?.calculationService
      ?.split(", ")
      ?.map((pair) => {
        const [key, value] = pair
          ?.split(":")
          ?.map((s) => s.trim()?.replace(/'/g, ""));
        return [key.toUpperCase(), parseFloat(value)];
      });

    const rateMap = entries ? Object.fromEntries(entries) : {};

    const dataForExcel = franchiseOrderRevenueData.map((item) => {
      const serviceName = item.name?.toUpperCase();
      const revenue = item.revenue || 0;
       let serviceWiserCharge = item.serviceWiserCharge || 0;
       let serviceWiserDiscount = item.serviceWiserDiscount || 0;
       let serviceWiserNetAmount = item.serviceWiserNetAmount || 0;
      const rate = parseFloat(rateMap[serviceName]) || 0;
      const sharingRevenue = revenue * (rate / 100);

      const currencySymbol = storeLocalData?.currencySymbol || "";

      return {
        "Service Name": item.name,
        [`Revenue (${currencySymbol})`]: revenue.toFixed(2),
        [`Charge (${currencySymbol})`]: serviceWiserCharge.toFixed(2),
        [`Discount (${currencySymbol})`]: serviceWiserDiscount.toFixed(2),
        [`NetAmount (${currencySymbol})`]: serviceWiserNetAmount.toFixed(2),
        "Sharing Rate (%)": rate.toFixed(2),
        [`Sharing Revenue (${currencySymbol})`]: sharingRevenue.toFixed(2),
      };
    });

    const totalRevenue = franchiseOrderRevenueData.reduce(
      (acc, item) => acc + (item.revenue || 0),
      0
    );

    const totalSharingRevenue = dataForExcel.reduce(
      (acc, item) => acc + parseFloat(item[`Sharing Revenue (${storeLocalData?.currencySymbol})`]),
      0
    );

    dataForExcel.push({});
    dataForExcel.push({
      "Service Name": "Total",
      [`Revenue (${storeLocalData?.currencySymbol})`]: totalRevenue.toFixed(2),
      "Sharing Rate (%)": "",
      [`Sharing Revenue (${storeLocalData?.currencySymbol})`]: totalSharingRevenue.toFixed(2),
    });

    return dataForExcel;
  };


  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const exportData = prepareExportData();
      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Franchise_Store_Service_Wise_Revenue");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };


  const renderDashboardCards = () => {
    const serviceRateList = localFranchiseRateValue.filter(
      (itemRate) =>
        itemRate.status === true && itemRate.calculationMode === "SERVICE"
    );

    // Parse the calculationService string into an object
    const entries = serviceRateList[0]?.calculationService
      ?.split(", ")
      ?.map((pair) => {
        const [key, value] = pair
          ?.split(":")
          ?.map((s) => s.trim()?.replace(/'/g, ""));
        return [key.toUpperCase(), parseFloat(value)];
      });

    let obj = entries ? Object.fromEntries(entries) : {};

    let totalCalculatedRevenue = 0;

    return (
      <Accordion>
        <AccordionTab
          style={{
            "--backgroundColor-AccordionTab": OrderStatusColors[0],
          }}
          header={`Services`}
        >
          <div className="cursor-pointer">
            {franchiseOrderRevenueData.map((item, index) => {
              const serviceName = item.name?.toUpperCase(); // Ensure match with obj keys

              let revenue = item.revenue || 0;
              let serviceWiserCharge = item.serviceWiserCharge || 0;
              let serviceWiserDiscount = item.serviceWiserDiscount || 0;
              let serviceWiserNetAmount = item.serviceWiserNetAmount || 0;
              let rate = parseFloat(obj[serviceName]) || 0;
              let calculatedRevenue = revenue * (rate / 100);

              // Accumulate total sharing revenue
              totalCalculatedRevenue += calculatedRevenue;

              return (
                <div className="flex-row mb-3" key={index}>
                  <div className="flex-1 p-1">
                    <p className="text-base font-semiBold capitalize">
                      Service:
                    </p>
                    <p className="text-lg font-bold capitalize">{item.name}</p>
                  </div>
                  <div className="flex-1 p-1">
                    <p className="text-base font-semiBold capitalize">
                      Revenue:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {storeLocalData?.currencySymbol} {revenue.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex-1 p-1">
                    <p className="text-base font-semiBold capitalize">
                      Charge:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {storeLocalData?.currencySymbol} {serviceWiserCharge.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex-1 p-1">
                    <p className="text-base font-semiBold capitalize">
                      Discount:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {storeLocalData?.currencySymbol} {serviceWiserDiscount.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex-1 p-1">
                    <p className="text-base font-semiBold capitalize">
                      Net Amount:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {storeLocalData?.currencySymbol} {serviceWiserNetAmount.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex-1 p-1">
                    <p className="text-base font-semiBold capitalize">
                      Sharing Rate (%):
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {rate.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex-1 p-1">
                    <p className="text-base font-semiBold capitalize">
                      Sharing Revenue:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {storeLocalData?.currencySymbol} {calculatedRevenue.toFixed(2)}
                    </p>
                  </div>
                </div>
              );
            })}
            <div className="flex-row mb-3">
              <div className="col-9">
                <p className="text-base font-semiBold capitalize">
                  Revenue Sharing Calculation (Service Wise):
                </p>
                <p className="text-lg font-bold capitalize">
                  Service Revenue x Revenue Sharing Rate = Calculated Share
                </p>
              </div>
              <div className="col-3">
                <p className="text-base font-semiBold capitalize">
                  Total Calculated Share
                </p>
                <p className="text-lg font-bold capitalize">
                  {storeLocalData?.currencySymbol} {totalCalculatedRevenue.toFixed(2)}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate(-1)
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Store Service Wise Revenue
              </p>
            </div>
          </div>
          {franchiseOrderRevenueData.length > 0 && (
            <div className="flex justify-content-center align-items-center">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={exportExcel}
                  src={"images/file.png"}
                  style={{
                    width: 30,
                  }}
                  alt=""
                />
              </div>
            </div>
          )}
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>

          {/*<div
            onClick={() => handleFilterModal("DELIVERED")}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>*/}

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2">
        <div className="mx-4 my-2">
          {franchiseOrderRevenueData.length > 0 ? (
            renderDashboardCards()
          ) : apiCall === false ? (
            <div className="flex justify-content-center my-2">
              <p className="text-2xl font-semi-bold" style={{color:"green"}}>Please Select Start Date & End Date to Get Revenue.</p>
            </div>
          ) : (
            <div className="flex justify-content-center my-2">
              <p className="text-4xl font-semi-bold">No Data Found</p>
            </div>
          )}
        </div>
        <SchedularModalFranchise
          setSchedularModalVisible={setSchedularModalVisible}
          schedularModalVisible={schedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
          minimumDateFranchise={item?.revenueCalculateOn}
        />
        <StatusFilterModal
          setStatusFilterModalVisible={setStatusFilterModalVisible}
          statusFilterModalVisible={statusFilterModalVisible}
          sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
          upDateSelectedStatus={upDateSelectedStatus}
          OrderStatus={[
            "BOOKED",
            "INPROCESS",
            "IN_WAREHOUSE",
            "PROCESSED",
            "DELIVERED",
            "DONE",
            "CANCEL",
            "UNPROCESSED",
            "OUT_FOR_DELIVERY",
            "DELAY_STATUS",
          ]}
        />
        <AdminMenu setVisible={setVisible} visible={visible} />
        <ButtonLink />
      </div>
    </div>
  );
};

export default FranchiseStoreServiceWiseRevenueAdmin;
